import { useState } from 'react';
import {
  ShiftChangeRequestColleagueApprovalStatus,
  useCancelShiftChangeRequestMutation,
  useRespondToShiftChangeRequestMutation,
} from '../../../__generated__/graphql';
import { useMutationErrorHandler } from '../../../../../hooks/useMutationErrorHandler';

export const useCancelShiftChangeRequest = () => {
  const errorHandler = useMutationErrorHandler();
  const [cancelRequest, { loading: isCancelling }] =
    useCancelShiftChangeRequestMutation();
  const [requestToCancel, setRequestToCancel] = useState<string | null>(null);

  const handleCancelClick = (requestId: string) => {
    setRequestToCancel(requestId);
  };

  const handleCancelConfirm = async () => {
    if (!requestToCancel) return;

    await cancelRequest({
      variables: {
        input: {
          id: requestToCancel,
        },
      },
    })
      .then(() => {
        setRequestToCancel(null);
      })
      .catch(errorHandler);
  };

  const handleCancelClose = () => {
    setRequestToCancel(null);
  };

  return {
    requestToCancel,
    isCancelling,
    handleCancelClick,
    handleCancelConfirm,
    handleCancelClose,
  };
};

export const useRespondToShiftChangeRequest = () => {
  const errorHandler = useMutationErrorHandler();
  const [respondRequest, { loading: isResponding }] =
    useRespondToShiftChangeRequestMutation();
  const [requestToRespond, setRequestToRespond] = useState<{
    id: string;
    status: ShiftChangeRequestColleagueApprovalStatus;
  } | null>(null);

  const handleAcceptClick = (requestId: string) => {
    setRequestToRespond({
      id: requestId,
      status: ShiftChangeRequestColleagueApprovalStatus.Accepted,
    });
  };

  const handleDeclineClick = (requestId: string) => {
    setRequestToRespond({
      id: requestId,
      status: ShiftChangeRequestColleagueApprovalStatus.Declined,
    });
  };

  const handleRespondConfirm = async () => {
    if (!requestToRespond) return;

    await respondRequest({
      variables: {
        input: {
          id: requestToRespond.id,
          colleagueApprovalStatus: requestToRespond.status,
        },
      },
    })
      .then(() => {
        setRequestToRespond(null);
      })
      .catch(errorHandler);
  };

  const handleRespondClose = () => {
    setRequestToRespond(null);
  };

  return {
    requestToRespond,
    isResponding,
    handleAcceptClick,
    handleDeclineClick,
    handleRespondConfirm,
    handleRespondClose,
  };
};
